module.exports = __webpack_public_path__ + "img/logo_sparco.bef6ac72.svg";